(function () {
  /* Valet gäller bara sidan där det gjordes – följer inte med in på ett mönster (Anders 2026-10-24) */
  var STORAGE = 'tambur-grid-cols:' + location.pathname;

  function mqMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function steps() {
    return [2, 3, 4, 5, 6];
  }

  function fallbackCols() {
    if (window.matchMedia('(max-width: 991px)').matches) return 3;
    return 4;
  }

  function clamp(n, list) {
    if (list.indexOf(n) !== -1) return n;
    var nearest = list[0];
    var best = 99;
    list.forEach(function (s) {
      var d = Math.abs(s - n);
      if (d < best) {
        best = d;
        nearest = s;
      }
    });
    return nearest;
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE);
      var n = raw ? parseInt(raw, 10) : NaN;
      return isNaN(n) ? null : n;
    } catch (e) {
      return null;
    }
  }

  function writeStored(n) {
    try {
      localStorage.setItem(STORAGE, String(n));
    } catch (e) {}
  }

  function currentCols() {
    if (mqMobile()) return 2;
    var list = steps();
    var stored = readStored();
    return clamp(stored || fallbackCols(), list);
  }

  function paintSlider(root, value) {
    root.querySelectorAll('[data-cols]').forEach(function (b) {
      var on = parseInt(b.getAttribute('data-cols'), 10) === value;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
  }

  function applyCols(value) {
    document.querySelectorAll('[data-collection-infinite].tambur-collection-grid-wrap--nf-editorial').forEach(function (wrap) {
      wrap.style.setProperty('--tambur-cols', String(value));
    });
  }

  function bindSlider(root) {
    if (root.getAttribute('data-grid-density-bound') === 'true') return;
    root.setAttribute('data-grid-density-bound', 'true');

    function valj(n) {
      writeStored(n);
      paintSlider(root, n);
      applyCols(n);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cols]');
      if (b) valj(parseInt(b.getAttribute('data-cols'), 10));
    });

    root.addEventListener('keydown', function (e) {
      var list = steps();
      var nu = root.querySelector('[data-cols].is-on');
      var idx = list.indexOf(nu ? parseInt(nu.getAttribute('data-cols'), 10) : 4);
      var ny = -1;
      if (e.key === 'ArrowRight' && idx < list.length - 1) ny = idx + 1;
      if (e.key === 'ArrowLeft' && idx > 0) ny = idx - 1;
      if (ny < 0) return;
      e.preventDefault();
      valj(list[ny]);
      var b = root.querySelector('[data-cols="' + list[ny] + '"]');
      if (b) b.focus();
    });
  }

  function init() {
    var value = currentCols();
    applyCols(value);
    document.querySelectorAll('[data-grid-density]').forEach(function (root) {
      paintSlider(root, value);
      bindSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('tambur:favorites-sync', init);
  window.addEventListener('resize', function () {
    var value = currentCols();
    applyCols(value);
    document.querySelectorAll('[data-grid-density]').forEach(function (root) {
      paintSlider(root, value);
    });
  });
})();
